import { Component, OnInit } from '@angular/core';
import { MarketBannerService } from '../market-banner/market-banner.service';
import { Subscription } from 'rxjs';
import { PreferencesService } from '../../api/services/preferences.service';

@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  styleUrls: ['./auth-shell.component.scss']
})
export class AuthShellComponent implements OnInit {

  warningMessages: string[] = [];
  marketSubscription: Subscription;
  constructor(
    private marketBannerService: MarketBannerService,
    private preferencesService: PreferencesService
  ) { }

  ngOnInit() {
    this.marketSubscription = this.marketBannerService.getMarketBanner()
      .subscribe(market => {
        if (market) {
          this.preferencesService.getPreferences('CUSTOMER', market.customerId).subscribe(prefs => {
            if (prefs['broadcast-message'] && prefs['broadcast-message'].Value) {
              let broadcastMessage = prefs['broadcast-message'].Value;
              if (broadcastMessage) {
                this.warningMessages = [];
                if (this.warningMessages.indexOf(broadcastMessage) == -1) {
                  this.warningMessages.push(broadcastMessage);
                }
              } else {
                this.warningMessages = [];
              }
            } else {
              this.warningMessages = [];
            }
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/auth-shell/auth-shell.component.ts